import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _dec, _class, _QuizEntryEditFooter;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { View } from '@instructure/ui-view';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Text } from '@instructure/ui-text';
import NumberInput from '@instructure/quiz-number-input';
import { IconButton } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import { IconDiscussionLine, IconDiscussionSolid } from '@instructure/ui-icons';
import { interactionPoints } from '@instructure/quiz-interactions';
import t from '@instructure/quiz-i18n/es/format-message';
import EntrySave from '../../../../../../common/components/resources/entry/EntrySave';
import { Flex, ITEM_FEEDBACK_MODAL, ITEM_FEEDBACK_MODAL_ITEM, ITEM_FEEDBACK_MODAL_FEEDBACK, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
function pointsAsFloat(pointsString) {
  return parseFloat(pointsString) || 0;
}
function countDecimals(normalizedPointsString) {
  if (!normalizedPointsString) return 0;
  // eslint-disable-next-line no-unused-vars
  var _normalizedPointsStri = normalizedPointsString.split('.'),
    _normalizedPointsStri2 = _slicedToArray(_normalizedPointsStri, 2),
    _ = _normalizedPointsStri2[0],
    decimals = _normalizedPointsStri2[1];
  return decimals ? decimals.length : 0;
}
export var QuizEntryEditFooter = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryEditFooter = /*#__PURE__*/function (_Component) {
  function QuizEntryEditFooter() {
    var _this;
    _classCallCheck(this, QuizEntryEditFooter);
    _this = _callSuper(this, QuizEntryEditFooter, arguments);
    _defineProperty(_this, "addFeedbackButton", null);
    _defineProperty(_this, "openFeedbackModal", function () {
      var workingEntry = _this.props.workingEntry;
      _this.props.setUi(ITEM_FEEDBACK_MODAL_ITEM, workingEntry);
      _this.props.setUi(ITEM_FEEDBACK_MODAL_FEEDBACK, workingEntry.feedback);
      _this.props.openModal(ITEM_FEEDBACK_MODAL, {
        modalTrigger: _this.addFeedbackButton
      });
    });
    _defineProperty(_this, "handlePointsBlur", function () {
      if (!_this.state.normalizedPoints) {
        _this.setState({
          points: '0'
        });
      }
    });
    _defineProperty(_this, "handlePointsChange", function (event, points, normalizedPoints) {
      // do not allow more than 3 decimals
      if (countDecimals(normalizedPoints) <= 3) {
        var pointsFloat = pointsAsFloat(normalizedPoints);
        if (pointsFloat !== _this.getPoints()) {
          var _this$props = _this.props,
            workingQuizEntry = _this$props.workingQuizEntry,
            workingEntry = _this$props.workingEntry;
          var qerIndexToUpdate = workingQuizEntry.quizEntryRegrades.findIndex(function (qer) {
            return qer.get('itemId') == workingEntry.id;
          });
          var newQuizEntryRegrades = qerIndexToUpdate > -1 ? workingQuizEntry.quizEntryRegrades.setIn([qerIndexToUpdate, 'pointsPossible'], null) : workingQuizEntry.quizEntryRegrades;
          _this.props.changeQuizEntryPoints(workingQuizEntry.id, pointsFloat, newQuizEntryRegrades.toJS());
        }
        _this.setState({
          points: points,
          normalizedPoints: normalizedPoints
        });
      }
    });
    _defineProperty(_this, "handleButtonRef", function (node) {
      _this.addFeedbackButton = node;
    });
    var _points = _this.getPoints();
    _this.state = {
      points: _points,
      normalizedPoints: _points
    };
    return _this;
  }
  _inherits(QuizEntryEditFooter, _Component);
  return _createClass(QuizEntryEditFooter, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var points = this.getPoints(nextProps);
      this.setState({
        points: points,
        normalizedPoints: points
      });
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var workingQuizEntry = props.workingQuizEntry,
        workingEntry = props.workingEntry;
      return workingQuizEntry.regradeAdjustedPointsPossible(workingEntry.id) || workingQuizEntry.pointsPossible || 0;
    }
  }, {
    key: "pointsDisabled",
    value: function pointsDisabled() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var workingEntry = props.workingEntry;
      var pointsFromItem = interactionPoints(workingEntry.toJS()) !== void 0;
      return pointsFromItem;
    }
  }, {
    key: "renderFeedbackSection",
    value: function renderFeedbackSection() {
      var _this$props2 = this.props,
        entry = _this$props2.entry,
        shouldClone = _this$props2.shouldClone,
        quizEntry = _this$props2.quizEntry,
        workingEntry = _this$props2.workingEntry;
      var disabled = entry.isImmutable() && !shouldClone || quizEntry.isBankEntry;
      var icon, text;
      if (workingEntry.hasFeedback()) {
        icon = IconDiscussionSolid;
        text = t('Edit Question Level Feedback (present)');
      } else {
        icon = IconDiscussionLine;
        text = t('Edit Question Level Feedback');
      }
      return jsx("div", {
        className: "feedbackSection",
        css: this.props.styles.feedbackSection,
        "data-automation": "sdk-quiz-entry-edit-footer-feedback-section"
      }, jsx(IconButton, {
        onClick: this.openFeedbackModal,
        withBackground: false,
        withBorder: false,
        disabled: disabled,
        ref: this.handleButtonRef,
        "data-automation": "sdk-open-feedback-modal-button",
        renderIcon: icon,
        screenReaderLabel: text
      }));
    }
  }, {
    key: "renderPointsSection",
    value: function renderPointsSection() {
      var currentPointsValue = this.state.points;
      return jsx("div", {
        css: this.props.styles.pointsSection
      }, jsx("span", {
        css: this.props.styles.pointsInput
      }, jsx(NumberInput, {
        renderLabel: jsx(ScreenReaderContent, null, t('Points Possible Input')),
        onChange: this.handlePointsChange,
        onBlur: this.handlePointsBlur,
        value: currentPointsValue,
        disabled: this.pointsDisabled(),
        "data-automation": "sdk-points-possible-numberinput",
        "aria-valuetext": "".concat(currentPointsValue, " ").concat(t('Points'))
      })), jsx(View, {
        margin: "none none none x-small"
      }, jsx(Text, {
        size: "small"
      }, t('Points'))));
    }
  }, {
    key: "renderLeftFooter",
    value: function renderLeftFooter() {
      return jsx("div", {
        css: this.props.styles.leftFooter
      }, this.renderPointsSection(), this.renderFeedbackSection());
    }
  }, {
    key: "renderRightFooter",
    value: function renderRightFooter() {
      if (this.props.alternativeRightFooter) {
        return this.props.alternativeRightFooter();
      }
      return jsx(EntrySave, {
        clearChanges: this.props.clearChanges,
        disableSubmit: this.props.disableSubmit,
        displayPosition: this.props.displayPosition,
        entry: this.props.entry,
        guid: this.props.guid,
        isValid: this.props.isValid,
        submitHandler: this.props.successfulSubmit,
        initialFocusId: this.props.initialFocusId,
        itemEditArea: this.props.itemEditArea
      });
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(View, {
        as: "div",
        background: "secondary",
        padding: "xx-small none"
      }, jsx(Flex, {
        wrap: "wrap",
        justifyItems: "space-between",
        alignItems: "center"
      }, jsx(Flex.Item, {
        padding: "xx-small small"
      }, this.renderLeftFooter()), jsx(Flex.Item, {
        padding: "xx-small small"
      }, this.renderRightFooter())));
    }
  }]);
}(Component), _defineProperty(_QuizEntryEditFooter, "displayName", 'QuizEntryEditFooter'), _defineProperty(_QuizEntryEditFooter, "componentId", "Quizzes".concat(_QuizEntryEditFooter.displayName)), _defineProperty(_QuizEntryEditFooter, "propTypes", {
  alternativeRightFooter: PropTypes.func,
  changeQuizEntryPoints: PropTypes.func.isRequired,
  clearChanges: PropTypes.func.isRequired,
  disableSubmit: PropTypes.bool,
  displayPosition: PropTypes.number.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  guid: PropTypes.string.isRequired,
  initialFocusId: PropTypes.string,
  isValid: PropTypes.bool.isRequired,
  itemEditArea: PropTypes.object,
  openModal: PropTypes.func.isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  setUi: PropTypes.func.isRequired,
  shouldClone: PropTypes.bool,
  successfulSubmit: PropTypes.func.isRequired,
  workingEntry: ImmutablePropTypes.record.isRequired,
  // This prop is flagged as unused, but it is actually used
  workingQuizEntry: ImmutablePropTypes.record.isRequired,
  styles: PropTypes.object
}), _defineProperty(_QuizEntryEditFooter, "defaultProps", {
  alternativeRightFooter: null,
  disableSubmit: false,
  initialFocusId: null,
  itemEditArea: null,
  shouldClone: false
}), _QuizEntryEditFooter)) || _class);
export default QuizEntryEditFooter;